export { default } from './AttachmentAlternate'
